// eslint-disable-next-line import/prefer-default-export
import {
    queryBot2, queryBot2Many, queryMany, queryOne,
} from 'boot/axios';
import { parseJson } from 'src/mixins/utils';

export class AccessInfo {
    constructor () {
        this.loaded = false;
        this.accessRows = [];
        this.accessRowsByTags = [];
        this.isSuperadmin = false;
        this.operatorId = undefined;
        this.logout = undefined;
        this.operator = undefined;
        this.operatorCourses = [];
    }

    async load (operatorKey) {
        localStorage.removeItem('operator-hashtags');
        if (operatorKey) {
            const op = await queryOne(`select id from operators where MD5(concat(id, email)) = '${operatorKey}'`);
            if (op) {
                localStorage.setItem('operatorId', op.id);
            } else {
                localStorage.removeItem('operatorId');
            }
        }
        const operatorId = localStorage.getItem('operatorId');
        let logout = false;
        if (operatorId) {
            await queryBot2('get-operator-info', { operatorId }).then(async (r) => {
                const [row] = r.data;
                this.operator = row;
                if (row) {
                    row.id = operatorId;
                    const tokenRow = await queryBot2Many('get-operator-token', { operatorId });
                    if (tokenRow[0]?.token) {
                        this.operator.token = tokenRow[0]?.token;
                    }
                    let level = 1;
                    const { isSuperadmin } = row;
                    if (isSuperadmin === '1') {
                        level = 3;
                    } else {
                        level = 1;
                    }
                    // загрузить все роли оператора (их может быть много)
                    await this.loadRoles(row);
                    localStorage.setItem('sprint-is-admin-logged', level);
                    localStorage.setItem('operator-hashtags', row.tags);
                } else {
                    // разлогинить
                    if (this.logout) {
                        this.logout();
                    }
                    logout = true;
                }
            });
            this.operatorCourses = await queryMany(`select * from operators_courses where operatorId = '${operatorId}'`);
        } else {
            // разлогинить
            if (this.logout) {
                this.logout();
            }
            logout = true;
        }
        if (logout) { return; }

        const isLogged = localStorage.getItem('sprint-is-admin-logged');
        this.operatorId = localStorage.getItem('operatorId');
        if (+isLogged === 3) {
            this.isSuperadmin = true;
            return;
        }
        if (isLogged) {
            // this.isSuperadmin = localStorage.getItem('isSuperadmin') === '1';
            this.isSuperadmin = false;
            await queryBot2('get-operator-acc', { operatorId }).then((r) => {
                this.accessRows = r.data;
            });
            await queryBot2('get-tags-acc').then((r) => {
                this.accessRowsByTags = r.data;
            });
        }
        this.loaded = true;
    }

    async loadRoles (operator) {
        const roleJson = parseJson(operator.roleJson, []);
        operator.roles = [];
        for (let i = 0; i < roleJson.length; i += 1) {
            const role = roleJson[i];
            const roleRow = await queryBot2('get-operator-role', { roleId: role });
            operator.roles.push(roleRow?.data[0]);
        }
    }
}

export const accessInfo = new AccessInfo();

export const AccessTypes = {
    None: 0,
    Read: 1,
    Modify: 2,
    Add: 3,
    Remove: 4,
    Access: 5,
};

export const ACCESS_LEVELS = [
    { label: 'Нет', value: AccessTypes.None, icon: 'lock' },
    { label: 'Видеть', value: AccessTypes.Read, icon: 'visibility' },
    { label: 'Менять', value: AccessTypes.Modify, icon: 'edit' },
    { label: 'Добавлять', value: AccessTypes.Add, icon: 'add' },
    { label: 'Удалять', value: AccessTypes.Remove, icon: 'delete' },
    { label: 'Права', value: AccessTypes.Access, icon: 'key' },
];
